/* eslint-disable camelcase */
/**
 * flow.js 内部使用 utils
 */
import type {IEmbedIframeInfo, IFrameInfo, IEmbedInlineBlockWorkCardInfo, IBlockWorkCardInfo} from './type.d';

/**
 * 标准化 Embed 嵌入信息
 *
 * @param info 原始嵌入信息对象
 */
export const normalizeEmbedInfo = (info: IFrameInfo): IEmbedIframeInfo => {
    const {from, urlValid, originUrl, userData} = info;
    const {block_info, redirect_url, appkey} = userData;

    return {
        from,
        urlValid,
        icon: block_info?.icon,
        title: block_info?.title,
        redirect_url,
        appkey,
        originUrl,
    };
};

/**
 * 将 Embed 嵌入式信息对象反归一化为原始格式
 *
 * @param info 标准化的 Embed 嵌入信息
 */
export const denormalizeEmbedInfo = (info: IEmbedIframeInfo): IFrameInfo => {
    const {from, urlValid, icon, title, redirect_url, appkey, originUrl} = info || {};

    return {
        from,
        urlValid,
        originUrl,
        userData: {
            block_info: {
                title,
                icon,
            },
            redirect_url,
            appkey,
        },
    };
};

/**
 * 标准化 Embed-Inline 嵌入信息
 *
 * @param info 原始嵌入信息对象
 */
export const normalizeEmbedInlineInfo = (info: IBlockWorkCardInfo): IEmbedInlineBlockWorkCardInfo => {
    const {from, urlValid, userData} = info;
    const {block_info, redirect_url, size_info} = userData!;

    return {
        from,
        urlValid: !!urlValid,
        icon: block_info.icon,
        title: block_info.title,
        redirect_url,
        defaultWidth: size_info?.defaultWidth,
        maxHeight: size_info?.maxHeight,
    };
};

/**
 * 将 Embed-Inline 嵌入式信息对象反归一化为原始格式
 *
 * @param info 标准化的 Embed-Inline 嵌入信息
 */
export const denormalizeEmbedInlineInfo = (info: IEmbedInlineBlockWorkCardInfo): IBlockWorkCardInfo => {
    const {from, urlValid, icon, title, redirect_url, defaultWidth, maxHeight} = info || {};

    return {
        from,
        urlValid: !!urlValid,
        userData: {
            block_info: {
                title,
                icon,
            },
            redirect_url,
            size_info: {
                defaultWidth,
                maxHeight,
            },
        },
    };
};
